import React, { useMemo } from 'react';
import { css } from 'linaria';
import { Breadcrumbs as FrontonBreadcrumbs, BreadcrumbsItem } from 'fronton-react';
import { Breadcrumb } from 'modules/model-json';
import { analyticsUtils } from 'utils/analytics-utils';

type BreadcrumbsProps = {
  breadcrumbs: Breadcrumb[] | undefined;
  currentPage: string;
  showCurrentPage: boolean;
};

const sectionStyle = css`
  margin-bottom: 24px;

  @media (--from-desktop) {
    margin-top: 24px;
  }
`;

/**
 * Вью компонента "Хлебные крошки"
 */
export const Breadcrumbs = ({ breadcrumbs = [], currentPage, showCurrentPage }: BreadcrumbsProps) => {
  /**
   * Отсекаем breadcrumb для текущей страницы
   */
  const filteredBreadcrumbs = useMemo(() => breadcrumbs.filter(({ link }) => link !== currentPage), [
    breadcrumbs,
    currentPage,
  ]);

  const finalBreadcrumbs = useMemo(() => (showCurrentPage ? breadcrumbs : filteredBreadcrumbs), [
    showCurrentPage,
    breadcrumbs,
    filteredBreadcrumbs,
  ]);

  const stringBreadcrumb = finalBreadcrumbs.map(({ label }) => label).join(' / ');

  const handleBreadCrumbClick = (label: string) => () => {
    analyticsUtils.clickButtonEvent(stringBreadcrumb, 'breadcrumbs', label);
  }

  const handleBreadCrumbWheelClick = (e: React.MouseEvent<HTMLAnchorElement>, breadcrumbLink: string) => () => {
    if (e.button === 1) {
      handleBreadCrumbClick(breadcrumbLink);
    }
  }

  return (
    <FrontonBreadcrumbs className={sectionStyle}>
      {finalBreadcrumbs?.map(({ link, label }: Breadcrumb, index: number) => (
        <BreadcrumbsItem
          href={link}
          breadcrumbIndex={index + 1}
          currentPage={link === currentPage}
          onClick={handleBreadCrumbClick(label)}
          onAuxClick={e => handleBreadCrumbWheelClick(e, label)}
          key={link}>
          {label}
        </BreadcrumbsItem>
      ))}
    </FrontonBreadcrumbs>
  );
};
